/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-11-08 15:49:54
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-03-02 22:06:11
 * @FilePath: /wemeet-web-activity/src/pages/tickets/hooks/useBuyTicket.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useState, useCallback, useEffect } from 'react';
import RegisterTicketRegist from "../../quickServices/RegisterTicketRegist";
import { FREE } from "../constant/ticket-pay-status";
import RegisterTicketQueryRegistStatus from "../../quickServices/RegisterTicketQueryRegistStatus";
import { message } from '@tencent/tea-component';
// import { ThemeContext } from '../context';

// 获取请求参数
const getRequest = (name, $urlSearch) => {
  let urlSearch = $urlSearch;
  if (!urlSearch) {
    [, urlSearch] = window.location.href.split('?');
  } else if (urlSearch.split('?')[1]) {
    [, urlSearch] = urlSearch.split('?');
  }
  if (urlSearch) {
    // 去除 hash 值
    [urlSearch] = String(urlSearch).split('#');
  }
  const res = new RegExp(`(^|&)${name}=([^&]*)`).exec(urlSearch);
  return !!res && res[2];
};
const useBuyTicket = (ticket, eventId, channelId, http) => {
  // const { http } = useContext(ThemeContext);
  const [buying, setBuying] = useState(false);
  let retryTime = 0;
  let timer;
  useEffect(() => () => {
    timer && clearTimeout(timer);
  }, []);
  const pollingRegistatus = useCallback(ticketData => {
    retryTime = retryTime + 1;
    const msg = message.loading({
      className: 'is-align-middle is-orient-vertical',
      content: '出票中...'
    });
    return new Promise(resolve => {
      RegisterTicketQueryRegistStatus({
        event_id: eventId,
        ticket_id: ticketData.ticket_id
      }, http).then(res => {
        msg.hide();
        const {
          status,
          b_polling: bPolling
        } = res.data || {};
        if (status === FREE.PAY_SUCC) {
          // 出票成功了
          resolve(status);
          return;
        }
        if (bPolling && status === FREE.APPROVAL) {
          if (retryTime >= 10) {
            resolve(status);
            return;
          }
          timer = setTimeout(() => {
            pollingRegistatus(ticketData).then(result => {
              resolve(result);
            });
          }, 500);
        } else {
          resolve(status);
        }
      });
    });
  }, []);
  const buyFreeTicket = useCallback(async answer => {
    // 免费票，直接购买
    setBuying(true);
    const msg = message.loading({
      className: 'is-align-middle is-orient-vertical',
      content: '正在报名...'
    });
    const res = await RegisterTicketRegist({
      event_id: eventId,
      ticket_group_id: Number(ticket.ticket_group_id) || 0,
      ticket_id: ticket.ticket_id || '',
      time_zone: ticket.time_zone || '',
      channel_id: channelId || getRequest('ch') || '0',
      source: getRequest('source') || '',
      source_identifier: JSON.stringify({
        meeting_id: getRequest('source_identifier') || '',
        site_type: getRequest('site_type') === '1' ? '1' : '0'
      }),
      question_list: answer
    }, http);
    if (res.code === 0) {
      // 免费票购票成功，跳转到成功页
      msg.hide();
      // 轮询一下审批状态，出完票之后才跳转过去
      const status = await pollingRegistatus(ticket);
      setBuying(false);
      return status;
    }

    // 失败，错误提示
    message.error({
      className: 'is-align-middle is-orient-vertical',
      content: res.msg || '网络异常请重试'
    });
    setBuying(false);
    return FREE.PAY_ERR;
  }, [ticket, buying]);
  return {
    buying,
    buyFreeTicket
  };
};
export default useBuyTicket;